<template>
<div>
  <div class="contact__info">
    <div class="first-col">
      <span class="fas fa-envelope"></span>
    </div>

    <div>
      <div>
      <h2>Kontakt aufnehmen</h2>

      <ul class="text-small list-unstyled">
        <li>
          <span class="text-primary">Adresse:</span>
          {{ company.street }}<br />
          <span></span> {{ company.zip }} {{ company.city }}
        </li>

        <li>
          <span class="text-primary">Telefon:</span>
          <a  class="text-normal" :href="'tel:' + company.phone">
              {{ company.phone }}
          </a>
        </li>

        <li>
          <span class="text-primary">E-Mail:</span>
          <a  class="link--arrow"  :href="'mailto:' + company.email">
            E-Mail senden</a>
        </li>
      </ul>
      </div>
    </div>
  </div>

  <div class="contact__info">
    <div class="first-col">
      <span class="fas fa-map-marker-alt"></span>
    </div>

    <div>
      <div>
        <h2>Ihr Weg zu uns</h2>

        <p class="text-small">
          Nehmen Sie mit uns Kontakt auf und vereinbaren Sie einen persönlichen Besprechungstermin. Wir freuen uns auf Sie.
        </p>

        <a :href="'https://www.google.de/maps?daddr=' + company.street + ', ' + company.zip + '+' + company.city + '&saddr='"
          title="Route jetzt berechnen"
          target="_blank"
          class="link--arrow">
            Route jetzt berechnen
        </a>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "ContactCompanyInfo",

  computed: {
    company() {
      return this.$yeti.company();
    }
  },

  methods: {
    onMapLoad(o) {
      o.L.marker(o.defaultCenter).addTo(o.map);
      this.mapCenter = o.defaultCenter;
    }
  }
}
</script>
